// Generated code for Big.Domain.Enums.OpleidingsType.
// Edit _Enum.tst to change the generated output.

export enum OpleidingsType {
    onbekend = 0,
    vooropleiding = 1,
    beroepsopleiding = 2,
    specifiekeVervolgopleiding = 3,
    periodiekRegistratieCertificaat = 4,
    inOpleidingTotSpecialist = 5
}
(OpleidingsType as any).name = 'OpleidingsType';
